import * as XLSX from 'xlsx';

export const importExcel = (onImport: (rows: any[]) => void) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.xlsx,.xls';
  input.onchange = (e: Event) => {
    const target = e.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) {
      document.body.removeChild(input);
      return;
    }
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = evt.target?.result;
      if (!data) {
        document.body.removeChild(input);
        return;
      }
      const workbook = XLSX.read(data, { type: 'binary' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      const rawRows = XLSX.utils.sheet_to_json<any[]>(worksheet, {
        header: 1,
        defval: '',
      }) as any[][];

      const rows = rawRows.map((row) =>
        row.reduce((acc: any, value: any, index: number) => {
          acc[index] = value;
          return acc;
        }, {}),
      );

      onImport(rows);

      document.body.removeChild(input);
    };
    reader.readAsBinaryString(file);
  };
  document.body.appendChild(input);
  input.click();
};

interface ExportExcelProps {
  sheets: { sheetName: string; data: { [key: string]: string | number }[] }[];
  fileName: string;
}

const isEmpty = (v: string | number) => v === '' || v == null;

const formatFilterSheet = (sheet: ExportExcelProps['sheets'][number]) => {
  const keys = Object.keys(sheet.data[0]);
  const someValue = keys.reduce((prev: any, key) => {
    if (sheet.data.some((row) => row[key])) prev[key] = true;

    return prev;
  }, {});

  const data = sheet.data.map((row) => {
    const filtered: { [key: string]: string | number } = {};
    for (const [key, value] of Object.entries(row)) {
      if (!isEmpty(value) || someValue[key]) filtered[key] = value;
    }
    return filtered;
  });
  return { ...sheet, data };
};

export const exportExcel = ({ sheets, fileName }: ExportExcelProps) => {
  const formattedSheets = sheets.map(formatFilterSheet);
  const excelBook = XLSX.utils.book_new();

  for (let i = 0; i < formattedSheets.length; i++) {
    const excelSheet = XLSX.utils.json_to_sheet(formattedSheets[i].data);

    const colWidth = 20;
    const cols = Object.keys(excelSheet).map(() => ({ wch: colWidth }));
    excelSheet['!cols'] = cols;

    XLSX.utils.book_append_sheet(excelBook, excelSheet, formattedSheets[i].sheetName);
  }

  XLSX.writeFile(excelBook, `${fileName}.xlsx`);
};
